import React, { useState, useRef } from 'react'
import {
    Input,
    Button,
    Typography,
    Spinner,
    Card,
    Progress

} from "@material-tailwind/react";
import Resizer from "react-image-file-resizer";
import { useShared } from '../../hooks/useShared';
import AIcon from '../partials/AIcon';
export default function UploadPhoto({ v }) {
    const { photo, setPhoto,model, progress, setProgress, consts, http, uploadPhoto } = useShared();
    const inputFile = useRef(null)


    console.log('model name', v.modelName);
    const onImageChange =async  event => {
        const files = event.target.files;
        if (files && files[0] && new RegExp("image/*").test(files[0].type)) {
            let img = files[0];
            img = await resizeFile(img);
            console.log(img)
            setPhoto({ url: URL.createObjectURL(img), photo: img, name: img?.name })

        }
        else {
            alert('Please upload only Image Format')
        }
        setProgress(0)
    };

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file,
                400,
                400,
                "JPEG",
                100,
                0,
                (uri) => {
                    resolve(uri);
                },
                "file"
            );
        });

    const handleClick = (e) => {
        e.preventDefault();
        inputFile.current.click()
    }

    const removePhoto = async (e) => {
        e.stopPropagation();

        if (window.confirm("Do you want to delete it?")) {
            inputFile.current.value = null;

            setPhoto(null);
            try {
                const res = await http.post('api/remove/photo', { attachment: model?.image_data })
                console.log(res);
            } catch (error) {
                console.log('error photo remove ', error);
            }
        }

    }


    const submit = () => {
        console.log("submit", model?.attachment)
        if ( photo) {
            uploadPhoto(model?.attachment ).then(res => {
                console.log(res)
                setPhoto(pre => ({ ...pre, name: null }))
            });
        }

    }



    return (
        <div className={v.className}>
            <Card className={`p-3 grid  `}>
                <p className="text-sm text-main-color font-bold mb-3 border-b pb-2">{v?.title}</p>
                <div style={{ backgroundImage: `url(${photo?.url})` }} 
                className={` cursor-pointer relative border border-main-color flex items-center justify-center bg-contain bg-no-repeat h-[200px] bg-center w-full rounded-md `} onClick={handleClick} >

                    {photo?.url ? <AIcon name="close" className="text-red-900 cursor-pointer hover:text-red-600 absolute top-0 right-0" size={20} onClick={removePhoto} /> :
                        <AIcon name="image-outline" size={80} className="text-main-color " />
                    }

                </div>
                <input
                    style={{ display: 'none' }}
                    ref={inputFile}
                    type="file"
                    accept='.png, .jpg'
                    onChange={onImageChange}
                />
                <div className='p-2'>{photo?.name}</div>


                {progress > 0 && <Progress color="green" value={progress} label="Completed" />}


                {v.showSumitButton && (photo?.name) && <Button color="green" onClick={submit}>ارسال</Button>
                }
            </Card>
        </div>
    )
}
